import { API_CONFIG, apiUtils } from '../config.js';

// Enrollment API for Promotion and Management
export const enrollmentApi = {
  // Bulk promote students
  promoteBulk: async (promotionData) => {
    const url = `${API_CONFIG.BASE_URL}/enrollment/promote-bulk`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'POST',
      body: JSON.stringify(promotionData),
    });
  },

  // Get suggested promotion mapping
  getPromotionMapping: async () => {
    const url = `${API_CONFIG.BASE_URL}/enrollment/promotion-mapping`;
    return apiUtils.makeAuthenticatedRequest(url);
  },
};

export default enrollmentApi;
